import Vue from 'vue'
import Router from 'vue-router'
import SayHi from '@/components/SayHi.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/SayHi',
      name: 'SayHi',
      component: SayHi
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js